import React from "react";
import type { Testimonial } from "../types/megapack";
import { E } from "./Emoji";
type TestimonialCardProps = {
  testimonial: Testimonial;
  variant?: "short" | "detailed";
};
export function TestimonialCard({
  testimonial: t,
  variant = "short"
}: TestimonialCardProps) {
  return <figure className="flex gap-3 rounded-2xl border border-line/50 bg-navy p-4" data-id="element-265" data-mp="2p7ga5u2tmkol">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy-2 text-xs font-black text-sky" data-id="element-266" data-mp="2u6rs36exbw7r">
        {t.initials}
      </span>
      <div className="min-w-0" data-id="element-267" data-mp="2z4b6c6bmg8zp">
        <p className="text-sm" aria-label="5 estrellas" data-id="element-268" data-mp="2z7p574l2u02e">
          <E data-id="element-269" data-mp="346a8jcvmkzv2">⭐⭐⭐⭐⭐</E>
        </p>
        {variant === "detailed" ? <>
            <p className="mt-1 font-black text-white" data-id="element-270" data-mp="385j48na877t9">{t.name}</p>
            <p className="text-xs text-mute" data-id="element-271" data-mp="19r7nbrdm03xy">
              <E data-id="element-272" data-mp="19s98iooca6te">{`📍 ${t.location}${t.version ? ` | ${t.version}` : ""}`}</E>
            </p>
            <blockquote className="mt-2 text-sm font-medium italic leading-snug text-white/90" data-id="element-273" data-mp="1dtb0qlju9ilv">
              “{t.quote}”
            </blockquote>
          </> : <>
            <blockquote className="mt-1 text-sm font-bold leading-snug text-white" data-id="element-274" data-mp="d1304wnz2zxw">“{t.quote}”</blockquote>
            <figcaption className="mt-1.5 text-xs font-semibold text-mute" data-id="element-275" data-mp="83t2wuucdjzi">
              — {t.name}, {t.location}
            </figcaption>
          </>}
      </div>
    </figure>;
}